var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5979: {
		fallback: function() { return function() { return __webpack_require__(1549); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	3352: {
		fallback: function() { return Promise.all([__webpack_require__.e(483), __webpack_require__.e(8136), __webpack_require__.e(513), __webpack_require__.e(817), __webpack_require__.e(9760)]).then(function() { return function() { return __webpack_require__(513); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",

	},
	9269: {
		fallback: function() { return __webpack_require__.e(8736).then(function() { return function() { return __webpack_require__(1899); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	6580: {
		fallback: function() { return Promise.all([__webpack_require__.e(483), __webpack_require__.e(2977)]).then(function() { return function() { return __webpack_require__(2977); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	3788: {
		fallback: function() { return Promise.all([__webpack_require__.e(8136), __webpack_require__.e(817), __webpack_require__.e(5900)]).then(function() { return function() { return __webpack_require__(6674); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	8048: {
		fallback: function() { return Promise.all([__webpack_require__.e(6240), __webpack_require__.e(817)]).then(function() { return function() { return __webpack_require__(6240); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	7720: {
		fallback: function() { return __webpack_require__.e(2012).then(function() { return function() { return __webpack_require__(54); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	7543: {
		fallback: function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(4194); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	977: {
		fallback: function() { return __webpack_require__.e(5390).then(function() { return function() { return __webpack_require__(5390); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	9372: {
		fallback: function() { return __webpack_require__.e(7899).then(function() { return function() { return __webpack_require__(7899); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	9964: {
		fallback: function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(8082); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	817: {
		fallback: function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(6321); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	141: {
		fallback: function() { return __webpack_require__.e(2444).then(function() { return function() { return __webpack_require__(54); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	8830: {
		fallback: function() { return __webpack_require__.e(7579).then(function() { return function() { return __webpack_require__(7579); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	5789: {
		fallback: function() { return __webpack_require__.e(8736).then(function() { return function() { return __webpack_require__(1899); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	9067: {
		fallback: function() { return __webpack_require__.e(3917).then(function() { return function() { return __webpack_require__(3917); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5979,3352,9269,6580,3788,8048,7720,7543,977,9372,5979,7543,9964,817,5789,141,8830,9067];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"179": [
		5979,
		7543,
		9964,
		817
	],
	"817": [
		817
	],
	"1137": [
		9269,
		6580,
		3788,
		8048,
		7720,
		7543,
		977,
		9372
	],
	"1944": [
		141,
		8830
	],
	"2888": [
		5789,
		141,
		8830,
		9067
	],
	"3352": [
		3352
	],
	"5979": [
		5979
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}